import Vue from 'vue'
import VueRouter from 'vue-router'
import Content from '../views/Content.vue'
import Background from '../views/Background.vue'
import Imprint from '../views/Imprint.vue'
import Story1 from '../views/Story-1.vue'
import Story2 from '../views/Story-2.vue'
import Story3 from '../views/Story-3.vue'
import Story4 from '../views/Story-4.vue'
import Story5 from '../views/Story-5.vue'
import Story6 from '../views/Story-6.vue'
import Story7 from '../views/Story-7.vue'
import Story8 from '../views/Story-8.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Content',
        component: Content
    },
    {
        path: '/background',
        name: 'Background',
        component: Background
    },
    {
        path: '/imprint',
        name: 'Imprint',
        component: Imprint
    },
    {
        path: '/sustainable-mobility',
        name: 'Story-1',
        component: Story1
    },
    {
        path: '/equality-education',
        name: 'Story-2',
        component: Story2
    },
    {
        path: '/gender-equality',
        name: 'Story-3',
        component: Story3
    },
    {
        path: '/meat-consumption',
        name: 'Story-4',
        component: Story4
    },
    {
        path: '/deforestation',
        name: 'Story-5',
        component: Story5
    },
    {
        path: '/affordable-energy',
        name: 'Story-6',
        component: Story6
    },
    {
        path: '/hiv-free-generation',
        name: 'Story-7',
        component: Story7
    },
    {
        path: '/decent-work',
        name: 'Story-8',
        component: Story8
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
